import {Space} from "antd";
import {useFormContext} from "react-hook-form";
import {IS_PWYW_ENABLED} from "../../../../services/config";
import {ServiceCurrenciesFormField} from "./currencies";
import {PwywCurrenciesFormField} from "../../general/pricing/pwyw-currencies";
import {ServiceSubPricingFormFields} from "./sub-pricing";
import {StoreServicePricingFormFieldsType} from "./types";

export function ServicePricingFormFields() {
  const {watch} = useFormContext<StoreServicePricingFormFieldsType>();
  const isPayWhatYouWant = IS_PWYW_ENABLED && watch("priceType") === "pwyw";

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <ServiceSubPricingFormFields />
      {isPayWhatYouWant ? (
        <PwywCurrenciesFormField />
      ) : (
        <ServiceCurrenciesFormField
          id="servicePrice"
          label="Other price"
          placeholder="100"
        />
      )}
    </Space>
  );
}
